import { cn } from "@oneleet/utils";

export const CircleNist = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
    >
      <g clipPath="url(#a)">
        <path
          d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
          fill="url(#b)"
        />
        <path
          d="M12 22.615c5.863 0 10.615-4.752 10.615-10.615S17.863 1.385 12 1.385 1.385 6.137 1.385 12 6.137 22.615 12 22.615Z"
          fill="url(#c)"
        />
        <g clipPath="url(#d)">
          <path
            d="M4.454 9.676c-.675 0-1.223.548-1.223 1.223l.01 3.399h1.086l-.009-2.261v-1.138a.137.137 0 0 1 .122-.135h.014c.037 0 .071.015.096.04l2.852 3.129a1.218 1.218 0 0 0 .865.358c.675 0 1.223-.548 1.223-1.223V9.671H8.403v3.402a.136.136 0 0 1-.232.091l-2.853-3.13a1.22 1.22 0 0 0-.864-.358Zm5.58-.005v3.398c0 .675.547 1.223 1.223 1.223h4.62a1.427 1.427 0 0 0 0-2.85v-.005h-2.99c-.15-.008-.27-.157-.27-.34 0-.182.12-.33.27-.34h4.892v3.534h1.088v-3.533h1.902V9.67h-7.882v.004a1.428 1.428 0 0 0 0 2.85h2.99c.151.009.272.157.272.34 0 .182-.12.331-.272.34h-4.62a.136.136 0 0 1-.136-.136V9.67h-1.088Z"
            fill="#fff"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
        <clipPath id="d">
          <path
            fill="#fff"
            transform="translate(3.23 9.67)"
            d="M0 0h17.538v4.659H0z"
          />
        </clipPath>
        <radialGradient
          id="c"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(90 0 12) scale(10.6154)"
        >
          <stop stopColor="#111010" />
          <stop offset="1" stopColor="#232222" />
        </radialGradient>
        <linearGradient
          id="b"
          x1="24"
          y1="24"
          x2="0"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#494746" />
          <stop offset="1" stopColor="#232222" />
        </linearGradient>
      </defs>
    </svg>
  );
};
